import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceRoutingModule } from './maintenance-routing.module';
import { FormsModule } from '@angular/forms';
import { MaintenanceComponent } from './maintenance.component';

@NgModule({
  imports: [CommonModule, FormsModule, MaintenanceRoutingModule],
  declarations: [MaintenanceComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaintenanceModule {}
